import utility from "core/Utils";

const { default: Header } = require("components/common/Header");
const {
  useOutletContext,
  Outlet,
  NavLink,
  useLocation,
} = require("react-router-dom");

const Masters = () => {
  const location = useLocation();
  const { token, menuPermissions } = useOutletContext();

  const menus = utility.buildSubMenuFromLocation(location, menuPermissions);
  const { name, client_name } = token;

  return (
    <div id="masters" className="page">
      <Header user={name} client_name={client_name} title="Masters">
        {menus.map(menu => (
          <NavLink
            className={({ isActive }) => (isActive ? "active" : undefined)}
            key={menu.item}
            to={utility.getLastPartOfPath(menu.pathname)}
          >
            {menu.item}
          </NavLink>
        ))}
      </Header>
      <Outlet context={token} />
    </div>
  );
};

export default Masters;
